var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7853 20.0584C21.7853 21.6118 23.0445 22.8709 24.5978 22.8709C26.1511 22.8709 27.4103 21.6117 27.4103 20.0584C27.4103 18.5052 26.1511 17.2459 24.5978 17.2459C23.0445 17.2459 21.7853 18.5051 21.7853 20.0584ZM24.5978 20.9959C24.08 20.9959 23.6603 20.5762 23.6603 20.0584C23.6603 19.5407 24.0801 19.1209 24.5978 19.1209C25.1156 19.1209 25.5353 19.5407 25.5353 20.0584C25.5353 20.5762 25.1156 20.9959 24.5978 20.9959Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.125 19.1209H26.4728V20.9959H32V8.90584H29.0265L26.5213 2.00391H18.1331V3.87891H25.2072L27.7124 10.7808H30.125V19.1209Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72281 20.0584C6.72281 21.6117 7.98198 22.8709 9.53531 22.8709C11.0886 22.8709 12.3478 21.6118 12.3478 20.0584C12.3478 18.5051 11.0886 17.2459 9.53531 17.2459C7.98196 17.2459 6.72281 18.5052 6.72281 20.0584ZM9.53531 20.9959C9.01752 20.9959 8.59781 20.5762 8.59781 20.0584C8.59781 19.5407 9.01754 19.1209 9.53531 19.1209C10.053 19.1209 10.4728 19.5407 10.4728 20.0584C10.4728 20.5762 10.0531 20.9959 9.53531 20.9959Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0625 12.6209H28.3056V14.4959H31.0625V12.6209Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9456 10.7808H28.3694V8.90585H22.8206V2.94141H20.9456V10.7808Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.9959H7.66031V19.1209H1.875V2.00391H17.1956V19.1209H11.4103V20.9959H19.0706V0.128906H0V20.9959Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84781 14.0074H14.2228V11.8049C14.2228 9.21608 12.1241 7.11741 9.53531 7.11741C6.94648 7.11741 4.84781 9.21608 4.84781 11.8049V14.0074ZM6.72281 12.1324V11.8049C6.72281 10.2516 7.98202 8.99241 9.53531 8.99241C11.0886 8.99241 12.3478 10.2516 12.3478 11.8049V12.1324H6.72281Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.279 12.1324H3.79154V14.0074H15.279V12.1324Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59781 6.24115V8.0549H10.4728V6.24115H8.59781Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7228 19.1209H18.1331V20.9959H22.7228V19.1209Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.e0449d492620eda13c65a5eebde33972.svg";
export { ForwardRef as ReactComponent };